module.exports = __webpack_public_path__ + "static/media/WeeklyMeals_Small.09b8c1aa.png";